import { render, staticRenderFns } from "./WorkgroupOrderCreate.vue?vue&type=template&id=45da06b0&scoped=true"
import script from "./WorkgroupOrderCreate.vue?vue&type=script&lang=js"
export * from "./WorkgroupOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./WorkgroupOrderCreate.vue?vue&type=style&index=0&id=45da06b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da06b0",
  null
  
)

export default component.exports